import { useState } from "react";
import Modal from "../../../../components/lib/modal";
import ConfirmCloseView from "../../../customers/components/confirmCloseView";
import AssetsService from "../../../../rest/assetsService";
import MenuService from "../../../../rest/menuService";
import { toast } from "react-toastify";
import RecipeRegisterStepper from "./recipeRegisterStepper";

const RecipeRegisterModal = ({ isOpen, setIsOpen }) => {
    const [hasData, setHasData] = useState(false);
    const [confirmClose, setConfirmClose] = useState(false);
    const [isSubmitting, setIsSubmitting] = useState(false);

    const requestClose = () => {
        if (hasData) {
            setConfirmClose(true);
        } else {
            setIsOpen(false);
        }
    };

    const forceClose = () => {
        setConfirmClose(false);
        setIsOpen(false);
    };

    const handleFinish = async ({ recipe, nutrition, image }) => {
        if (isSubmitting) return;
        setIsSubmitting(true);

        try {
            let imageUrl = null;

            if (image) {
                const formData = new FormData();
                formData.append("file", image);
                const upload = await AssetsService.uploadProductImage(formData);
                imageUrl = upload.data;
            }

            await MenuService.registerRecipe({
                ...recipe,
                nutritionalFacts: JSON.stringify(nutrition),
                imageUrl,
                clientCode: sessionStorage.getItem("clientCode"),
            });

            toast.success("Receita cadastrada com sucesso!");
            setIsOpen(false);
        } catch (err) {
            console.error(err);
            toast.error("Erro ao cadastrar receita.");
        } finally {
            setIsSubmitting(false);
        }
    };

    return (
        <Modal
            isOpen={isOpen}
            setIsOpen={requestClose}
            title="Cadastrar Receita"
            hideFooter
            maxWidth="max-w-xl lg:max-w-2xl md:-mr-16"
        >
            <div className="relative h-full flex flex-col">
                <RecipeRegisterStepper
                    onDirty={() => setHasData(true)}
                    onCancel={requestClose}
                    onFinish={handleFinish}
                    isSubmitting={isSubmitting}
                />

                {confirmClose && (
                    <div className="absolute inset-0 z-50 flex items-center justify-center bg-white/95 backdrop-blur-sm p-4 rounded-lg">
                        <ConfirmCloseView
                            onCancel={() => setConfirmClose(false)}
                            onConfirm={forceClose}
                        />
                    </div>
                )}
            </div>
        </Modal>
    );
};

export default RecipeRegisterModal;